import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import PageSection from './PageSection';
import * as styles from './PageSectionHalfBleed.module.css';
import RichTextConverter from './RichText/RichTextConverter';

const PageSectionHalfBleed = ({ title, body, imageObj, bgColor, bgUrl, className = '' }) => {
  const imageData = get(imageObj, 'gatsbyImageData');
  const bgImg = `url('${bgUrl}')`;

  let image = !!imageData ? (
    <GatsbyImage
      data-ot-ignore
      image={imageData}
      alt={title || ''}
      style={{ overflow: 'visible' }}
      className={styles.imgWrap}
    />
  ) : (
    <img alt={title || ''} loading="lazy" src={get(imageObj, 'file.url', '')} />
  );
  return (
    <PageSection className={styles.section} style={{ '--bgColor': bgColor, '--bgImg': bgImg }}>
      <div className={[styles.container, className].join(' ')}>
        <div className={styles.column}>{image}</div>
        <div className={styles.column2}>
          <h2>{title}</h2>
          {body && body.raw && (
            <div className={styles.content}>
              <RichTextConverter copy={body} />
            </div>
          )}
          {body && !body.raw && <div className={styles.content}>{body}</div>}
        </div>
      </div>
    </PageSection>
  );
};

PageSectionHalfBleed.propTypes = {
  /**
   * the heading for the card
   */
  title: PropTypes.string,
  /**
   * Provide rich text raw json if using the contentful RTE
   */
  bodyRawJson: PropTypes.string,
  /**
   * Image object
   */
  imageObj: PropTypes.object,
  /**
   * Background color. Pass in a hex value
   */
  bgColor: PropTypes.string,
  /**
   * Background Image. Usually used as a gradient on the left side of the grid
   */
  bgUrl: PropTypes.string,
};

export default PageSectionHalfBleed;
